module.exports = __webpack_public_path__ + "static/img/tipdmIntro-1.0bca7efc.jpg";